<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-6">
    @if(!processing() && pool) {
      <app-competition-timeline [competitionConfig]="pool.getCompetitionConfig()"></app-competition-timeline>
    }
    <h2>
      <fa-icon [icon]=faUsers></fa-icon> deelnemers
    </h2>

    @if(processing()) {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
    

    @if(alert) {
    <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
    }


    @if(!processing() && pool) {
      @if(pool.getAssemblePeriod().isIn()) {
        <ngb-alert type="warning">Let op: wanneer je team incompleet is, doet het NIET mee</ngb-alert>
      }

      <table class="table">
        <thead>
          <tr>
            <th>naam</th>
            @if(pool.transferPeriodNotStarted()) {
              <th>gekozen spelers</th>
            }
            @if(pool.getTransferPeriod().isIn()) {
              <th>transfers</th>
            }
            <!-- <th></th> -->
          </tr>
        </thead>
        <tbody>
          @for(poolUser of poolUsers;track poolUser.getId()) {
          <tr>
            <td>
              {{poolUser.getName()}}
            </td>
            @if(pool.transferPeriodNotStarted()) {
              <td>
                @if(poolUser.getNrOfAssembled() < 15) {
                  <fa-icon [icon]=faTimesCircle class="text-danger"></fa-icon>
                } 
                @else {
                  <fa-icon [icon]=faCheckCircle class="text-success"></fa-icon>
                }              
                {{poolUser.getNrOfAssembled()}}/15
              </td>
            }
            @if(pool.getTransferPeriod().isIn()) {
              <td>
                {{poolUser.getNrOfTransfers()}}/{{pool.getTransferPeriod().getMaxNrOfTransfers()}}
              </td>
            }
            
            <!-- <td class="text-end">
              @if(!poolUser.getAdmin() && canBeRemoved()){
              <button type="button" class="btn btn-sm btn-danger"
                [disabled]="processing" (click)="openRemoveApprovalModal(poolUser)">
                <fa-icon [icon]=faTrashAlt></fa-icon>
              </button>
              }
            </td> -->
          </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>

@if(!processing() && pool) {
<app-pool-navbar [current]="PoolUsers" [pool]="pool" [poolUser]="poolUserFromSession"></app-pool-navbar>
}